import React from 'react';
import { Search } from 'lucide-react';
import CustomSelect from '../../ui/CustomSelect';

interface DebtorFiltersProps {
  searchTerm: string;
  setSearchTerm: (value: string) => void;
  filterStatus: string;
  setFilterStatus: (value: string) => void;
  filterDocStatus: string;
  setFilterDocStatus: (value: string) => void;
}

const statusOptions = [
  { value: 'all', label: 'Semua Status' },
  { value: 'active', label: 'Aktif' },
  { value: 'inactive', label: 'Tidak Aktif' },
  { value: 'blocked', label: 'Diblokir' },
];

const docStatusOptions = [
  { value: 'all', label: 'Semua Dokumen' },
  { value: 'complete', label: 'Lengkap' },
  { value: 'incomplete', label: 'Tidak Lengkap' },
  { value: 'expired', label: 'Kadaluarsa' },
];

export default function DebtorFilters({
  searchTerm,
  setSearchTerm,
  filterStatus,
  setFilterStatus,
  filterDocStatus,
  setFilterDocStatus,
}: DebtorFiltersProps) {
  return (
    <div className="bg-white rounded-lg border shadow-sm p-4">
      <div className="flex flex-col md:flex-row gap-4">
        <div className="relative flex-1">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
          <input
            type="text"
            placeholder="Cari nama, CIF, atau No. Identitas..."
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-amber-500 outline-none"
          />
        </div>
        <CustomSelect
          value={filterStatus}
          onChange={setFilterStatus}
          options={statusOptions}
          placeholder="Status"
          width="w-full md:w-40"
        />
        <CustomSelect
          value={filterDocStatus}
          onChange={setFilterDocStatus}
          options={docStatusOptions}
          placeholder="Status Dokumen"
          width="w-full md:w-48"
        />
      </div>
    </div>
  );
}
